import { createSelector } from 'reselect';
import isNull from 'lodash/isNull';
import moment from 'moment';

const defaultInitialState = {
	value: null,
	tmpValue: null,
	isOpen: false,
	isRightPosition: true
};

const createDatePicker = ({
	namespace,
	stateNodeName,
	defaultValue
}) => {
	// action types
	const TOGGLE = `${namespace}/${stateNodeName}-toggle`;
	const CHANGE = `${namespace}/${stateNodeName}-change`;
	const APPLY = `${namespace}/${stateNodeName}-apply`;

	// init state
	const initialState = {
		...defaultInitialState,
		value: defaultValue
	};

	// actions
	const actions = {
		[`${stateNodeName}Toggle`]: () => ({ type: TOGGLE }),
		[`${stateNodeName}Change`]: date => ({
			type: CHANGE,
			payload: date
		}),
		[`${stateNodeName}Apply`]: date => ({
			type: APPLY,
			payload: date
		})
	};

	// reducers
	const reducers = {
		[TOGGLE]: (state, action) => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				isOpen: !state[stateNodeName].isOpen
			}
		}),
		[CHANGE]: (state, action) => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				tmpValue: moment(action.payload).format('YYYY-MM-DD')
			}
		}),
		[APPLY]: (state, action) => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				isOpen:false,
				value: isNull(state[stateNodeName].tmpValue) ?
					state[stateNodeName].value : state[stateNodeName].tmpValue
			}
		})
	};

	// selectors
	const selectors = {
		getDatePicker: (datePickerSelector, appState) => createSelector(
			datePickerSelector,
			appState,
			(datePicker, appState) => {
				const date = moment(datePicker.value);
				const formattedDate = date.format('DD.MM.YYYY');

				return {
					...datePicker,
					date,
					formattedDate
				};
			}
		)
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createDatePicker;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/date-picker/index.js